// @flow

import getStrategyFunctionByType from './get-strategy-function-by-type';

const facetsHiddenByStrategy = (facet: FacetWithConfig): boolean => (
    getStrategyFunctionByType(facet.type)(facet)
);

export default facetsHiddenByStrategy;
